import type { ColumnDef } from '@tanstack/react-table';

import { Can } from '@/components/can/Can';
import { DataTableColumnHeader } from '@/components/dataTable/ColumnHeader';
import { getSerialNumber } from '@/components/dataTable/data-table.utils';
import { PERMS } from '@/features/auth/permissions/permissionKeys';
import { Configuration } from '@/icons';
import { formatDate } from '@/lib/dateFormatter';
import { ROLESTABLEDATA } from '@/services/rolesPrivilege/roles.types';
import { Link } from '@tanstack/react-router';

export function getColumns(roleId: string | null, t: (key: string) => string): ColumnDef<ROLESTABLEDATA>[] {
  return [
    {
      accessorKey: 'S.N',
      header: ({ column }) => <DataTableColumnHeader column={column} title={t('common.page.tableColumn.sn')} />,
      cell: ({ row, table }) => <div>{getSerialNumber(table, row.index)}</div>,
      enableHiding: false,
    },
    {
      accessorKey: 'roleName',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('userManagement.rolesAndPrivileges.table.roleTitle')} />
      ),
      cell: ({ row }) => <div className="font-medium truncate max-w-[20rem]">{row.getValue('roleName')}</div>,
      meta: {
        label: 'Title',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'roleDescription',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('userManagement.rolesAndPrivileges.table.description')} />
      ),
      cell: ({ row }) => <div>{row.getValue('roleDescription')}</div>,
      meta: {
        label: 'Description',
      },
      enableHiding: false,
    },
    {
      accessorKey: 'createdBy',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('userManagement.rolesAndPrivileges.table.createdBy')} />
      ),
      cell: ({ row }) => <div>{row.getValue('createdBy')}</div>,
      meta: {
        label: 'Created By',
      },
      enableHiding: false,
    },
    {
      id: 'createdDate',
      accessorKey: 'createdDate',
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title={t('userManagement.rolesAndPrivileges.table.createdDate')} />
      ),
      cell: ({ row }) => <div>{formatDate(row.getValue('createdDate'))}</div>,
      meta: {
        label: 'Created At',
      },
      enableHiding: false,
    },
    {
      id: 'actions',
      accessorKey: 'roleId',
      header: ({ column }) => (
        <DataTableColumnHeader
          column={column}
          title={t('userManagement.rolesAndPrivileges.table.action')}
          className="whitespace-nowrap"
        />
      ),
      cell: ({ row }) => (
        <div className="flex items-center gap-2 ">
          <Can rule={{ allOf: [PERMS.role.permission.functionList] }}>
            {row.original.roleId !== roleId && (
              <Link
                to={`/users/roles/privilege/$roleId`}
                params={{
                  roleId: row.original.roleId,
                }}
                search={{
                  roleName: row.original.roleName,
                }}
                className="text-link cursor-pointer"
              >
                <Configuration className="text-link cursor-pointer" size={'16'} />
              </Link>
            )}
          </Can>
        </div>
      ),
      size: 40,
      enableHiding: false,
    },
  ];
}
